import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-16 lg:py-24" data-id="element-27" data-mp="1bmlnvb30w3m2">
      <div className="mx-auto max-w-3xl px-5" data-id="element-28" data-mp="1gitycb69z8mw">
        <h2 className="text-center font-display text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-29" data-mp="1glpvhxaattaa">
          Frequently Asked Questions
        </h2>
        <ul className="mt-10 border-t border-line" data-id="element-30" data-mp="28b1df764ucz6">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <li key={faq.q} className="border-b border-line" data-id="element-31" data-mp="1zhy1x4f1sa76" data-mpi={i}>
                <h3 data-id="element-32" data-mp="1zgd67bgzyl7q">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={id} className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-lg font-bold text-navy focus:outline-none focus-visible:text-aqua" data-id="element-33" data-mp="2n8bx33sxip5z">
                    {faq.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-aqua transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-34" data-mp="1em57ttvozb10" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-35" data-mp="1jjojqn4x3bps">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-36" data-mp="1xiob42jte4pn">
                      <p className="pb-5 pr-8 leading-relaxed text-ink" data-id="element-37" data-mp="1ya4w6v5rs2wt">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}